import { useEffect, useState, useCallback, useRef } from "react";
import "./News.css";
import { CallApiGetNews } from "../../../Api/Enforcement";
import { Path } from "../../../Api/Path";
import { clientNewsDetail } from "../../../Api/SubUrl";
import imageError from "../../../Css/img/backGround1.jpg";

const PAGE_SIZE = 10;

function HotSkeleton() {
  return (
    <div className="item hot news-skeleton" aria-hidden="true">
      <div className="cover">
        <div className="sk sk-hot-img" />
      </div>
      <div className="detail">
        <div className="sk sk-line sk-title" />
        <div className="sk sk-line" />
        <div className="sk sk-line" />
        <div className="sk sk-line sk-short" />
      </div>
    </div>
  );
}

function ListSkeleton() {
  return Array.from({ length: 4 }, (_, i) => (
    <div key={i} className="item news-skeleton" aria-hidden="true">
      <div className="cover">
        <div className="sk sk-thumb" />
      </div>
      <div className="detail">
        <div className="sk sk-line" />
        <div className="sk sk-line sk-short" />
      </div>
    </div>
  ));
}

function NewsComponent() {
  const NEWS = "NEWS";
  const EVENT = "EVENT";
  const GUID = "GUID";

  const [search, setSearch] = useState("");
  const [type, setType] = useState(NEWS);
  const [listCover, setListCover] = useState([]);
  const [loading, setLoading] = useState(false);
  const latestRequest = useRef(0);

  const handleCallApiNew = useCallback(
    (searchText = "") => {
      const param = {
        type: type,
        page: 0,
        pageSize: PAGE_SIZE,
        search: searchText,
      };
      const requestId = ++latestRequest.current;
      setLoading(true);
      CallApiGetNews(param, (res) => {
        // Bỏ qua response cũ khi đã có request mới hơn (đổi tab/tìm kiếm nhanh)
        if (requestId !== latestRequest.current) return;
        setLoading(false);
        if (res.Status === "success") {
          setListCover(res.Response?.data?.Items || []);
        } else {
          // Lỗi (vd 400) thì xóa dữ liệu cũ, không hiển thị item của type trước
          setListCover([]);
        }
      });
    },
    [type]
  );

  const handleChangPage = (ID) => {
    const url = `${clientNewsDetail}${ID}`;
    window.open(url, "_blank");
  };

  const handleSearch = useCallback(() => {
    handleCallApiNew(search);
  }, [search, handleCallApiNew]);

  useEffect(() => {
    handleCallApiNew();
    const requests = latestRequest;
    return () => {
      requests.current++;
    };
  }, [type, handleCallApiNew]);

  return (
    <div className="news">
      <div className="nav">
        <ul>
          <li>
            <p onClick={() => setType(NEWS)}>Tin tức</p>
          </li>
          <li>
            <p onClick={() => setType(EVENT)}>Sự kiện</p>
          </li>
          <li>
            <p onClick={() => setType(GUID)}>Hướng dẫn</p>
          </li>
        </ul>
        <div className="search">
          <input
            type="text"
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Nhập từ khóa tìm kiếm"
          />
          <button onClick={handleSearch}>+</button>
        </div>
      </div>
      <div
        className={`list-news${!loading && listCover?.length === 1 ? " single" : ""}`}
        aria-busy={loading}
      >
        {loading && <HotSkeleton />}
        {!loading && listCover?.map((item, index) => {
          if (index === 0) {
            return (
              <div key={index} className="item hot">
                <div onClick={() => handleChangPage(item.ID)} className="cover">
                  <p target="_blank" title={item.Title}>
                    <img
                      src={Path.imageCDN + item.Img}
                      alt={item.Title}
                      onError={(e) => {
                        e.target.src = imageError;
                      }}
                    />
                  </p>
                </div>
                <div className="detail">
                  <p target="_blank" alt={item.Title}>
                    <h3 title={item.Title}>{item.Title}</h3>
                  </p>
                  <p className="desc">{item.shortText}</p>
                  <a
                    href={`${clientNewsDetail}${item.ID}`}
                    alt={item.Title}
                    title={item.Title}
                    rel="noopener noreferrer"
                    target="_blank"
                    className="viewmore"
                  >
                    Xem thêm »
                  </a>
                </div>
              </div>
            );
          }
          return null;
        })}

        <div className="list mCustomScrollbar _mCS_1">
          <div
            id="style-1"
            className="mCustomScrollBox mCS-light mCSB_vertical mCSB_inside"
            style={{ maxHeight: "300px" }}
            tabIndex="0"
          >
            <div
              id="mCSB_1_container"
              className="mCSB_container"
              style={{ position: "relative", top: 0, left: 0 }}
              dir="ltr"
            >
              {loading && <ListSkeleton />}
              {!loading && listCover?.slice(1).map((item) => {
                return (
                  <div key={item.ID} className="item ">
                    <div
                      onClick={() => handleChangPage(item.ID)}
                      className="cover"
                    >
                      <p target="_blank" title={`${item.Title}`}>
                        <img
                          src={Path.imageCDN + item.Img}
                          alt={`${item.Title}`}
                          onError={(e) => {
                            e.target.src = imageError;
                          }}
                          loading="lazy"
                          decoding="async"
                          className="mCS_img_loaded"
                        />
                      </p>
                    </div>
                    <div className="detail">
                      <p target="_blank" alt={`${item.Title}`}>
                        <h3 title={`${item.Title}`}>
                          {item.Title}
                        </h3>
                      </p>
                      <p className="desc">{item.shortText}</p>
                      <p target="_blank" className="viewmore">
                        Xem thêm »
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
            <div
              id="mCSB_1_scrollbar_vertical"
              className="mCSB_scrollTools mCSB_1_scrollbar mCS-light mCSB_scrollTools_vertical"
              style={{ display: "block" }}
            >
              <div className="mCSB_draggerContainer">
                <div
                  id="mCSB_1_dragger_vertical"
                  className="mCSB_dragger"
                  style={{
                    position: "absolute",
                    minHeight: "30px",
                    display: "block",
                    height: "55px",
                    maxHeight: "290px",
                    top: "0px",
                  }}
                >
                  <div
                    className="mCSB_dragger_bar"
                    style={{ lineHeight: "30px" }}
                  ></div>
                </div>
                <div className="mCSB_draggerRail"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewsComponent;
